import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import {
  Box,
} from '@material-ui/core';

import Button from 'src/components/Button';
import Card from 'src/components/Card';
import TasksLedger from 'src/views/shared/TasksLedger';

interface Props {
  title: string,
  url: string,
  seeAllRoute?: string,
}

function TasksCard({ seeAllRoute, url, title }: Props) {
  const footer = seeAllRoute ? (
    <Box
      p={2}
      display="flex"
      justifyContent="flex-end"
    >
      <Button
        component={RouterLink}
        size="small"
        to={seeAllRoute}
      >
        See all
        <NavigateNextIcon />
      </Button>
    </Box>
  ) : null;

  return (
    <Card title={title} footer={footer} p={0}>
      <TasksLedger url={url} />
    </Card>
  );
}

export default TasksCard;
